import { render } from "./tiqianfengpan.vue?vue&type=template&id=1dcdf41c&scoped=true"
import script from "./tiqianfengpan.vue?vue&type=script&lang=js"
export * from "./tiqianfengpan.vue?vue&type=script&lang=js"

import "./tiqianfengpan.vue?vue&type=style&index=0&id=1dcdf41c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcdf41c"]])

export default __exports__